const IconIndeterminate = () => {
  return (
    <svg
      width="6"
      height="2"
      viewBox="0 0 6 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.5C0 0.223858 0.167893 0 0.375 0H5.625C5.83211 0 6 0.223858 6 0.5V1.5C6 1.77614 5.83211 2 5.625 2H0.375C0.167893 2 0 1.77614 0 1.5V0.5Z"
        fill="white"
      />
    </svg>
  )
}

export default IconIndeterminate
